import { useMemo } from 'react';
import { useMediaQuery } from './useMediaQuery';

export const useResponsive = () => {
  const isMobile = useMediaQuery('(max-width: 840px)');
  const isTablet = useMediaQuery('(min-width: 601px) and (max-width: 840px)');
  const isSmallScreen = useMediaQuery('(min-width: 841px) and (max-width: 1024px)');
  const isPortrait = useMediaQuery('orientation: portrait');
  const isLandscape = useMediaQuery('orientation: landscape');

  return useMemo(
    () => ({
      isMobile,
      isTablet,
      isSmallScreen,
      isPortrait,
      isLandscape,
    }),
    [isMobile, isTablet, isSmallScreen, isPortrait, isLandscape],
  );
};
